module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-23.bb5fb852.svg";